import signUpNewJson from '../../../assets/translations/sign-up-new.json'

export const signUpNewContent: any = signUpNewJson
